import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import axios from 'axios';
import { Trophy, Star, Medal } from 'lucide-react';
import './Leaderboard.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function Leaderboard() {
  const { t } = useTranslation();
  const [leaderboard, setLeaderboard] = useState([]);
  
  useEffect(() => {
    loadLeaderboard();
  }, []);
  
  const loadLeaderboard = async () => {
    try {
      const response = await axios.get(`${API}/leaderboard`, { withCredentials: true });
      setLeaderboard(response.data);
    } catch (error) {
      console.error('Failed to load leaderboard:', error);
    }
  };
  
  const getMedalIcon = (rank) => {
    if (rank === 1) return <Medal size={32} color="#FFD700" />;
    if (rank === 2) return <Medal size={32} color="#C0C0C0" />;
    if (rank === 3) return <Medal size={32} color="#CD7F32" />;
    return <span className="rank-number">{rank}</span>;
  };
  
  return (
    <div className="leaderboard-page" data-testid="leaderboard-page">
      <div className="leaderboard-container">
        <motion.div
          className="page-header"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <Trophy size={48} color="#FFD700" />
          <h1>{t('leaderboard')}</h1>
        </motion.div>
        
        {leaderboard.length === 0 ? (
          <div className="empty-state">
            <p>No players on the leaderboard yet. Be the first!</p>
          </div>
        ) : (
          <div className="leaderboard-list">
            {leaderboard.map((player, index) => (
              <motion.div
                key={player.user_id}
                className={`leaderboard-item ${player.rank <= 3 ? 'top-three' : ''}`}
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.05 }}
                data-testid={`leaderboard-item-${index}`}
              >
                <div className="rank-section">
                  {getMedalIcon(player.rank)}
                </div>
                
                <div className="player-info">
                  {player.picture && (
                    <img src={player.picture} alt={player.name} className="player-avatar" />
                  )}
                  <span className="player-name">{player.name}</span>
                </div>
                
                <div className="player-stats">
                  <div className="stat">
                    <Star size={20} color="#FFE66D" />
                    <span>{player.total_stars}</span>
                  </div>
                  <div className="stat">
                    <span className="score-label">{t('score')}:</span>
                    <span className="score-value">{player.total_score}</span>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Leaderboard;
